import { datadogRum } from '@datadog/browser-rum';

export const trackError = (error: Error, opts?: Record<string, unknown>): void => {
  datadogRum.addError(error, opts);
};
